import BaseRequest from './index'
import { JoinContestPayload } from '../redux/types/xContest'

class XContestServices extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.joinXcontest = this.joinXcontest.bind(this)
    this.getAllContests = this.getAllContests.bind(this)
    this.getUserContests = this.getUserContests.bind(this)
    this.getUserContestLeaderboard = this.getUserContestLeaderboard.bind(this)
    this.getUserContestsActivities = this.getUserContestsActivities.bind(this)
    this.deleteContest = this.deleteContest.bind(this)
  }

  async joinXcontest<T>(payload: JoinContestPayload): Promise<T> {
    return await this.api.post('/user/contest/join', payload)
  }

  async getAllContests<T>(): Promise<T> {
    return await this.api.get('/user/contest/all')
  }

  async getUserContests<T>(): Promise<T> {
    return await this.api.get('/user/contest')
  }

  async getUserContestsActivities<T>(id: string): Promise<T> {
    return await this.api.get(`/user/contest/${id}/activities`)
  }

  async getUserContestLeaderboard<T>(id: string): Promise<T> {
    return await this.api.get(`user/contest/${id}/leaderboard`)
  }

  async deleteContest<T>(id: string): Promise<T> {
    return await this.api.delete(`/user/contest/${id}/exit`)
  }
}

const xContestServices = new XContestServices()

export default xContestServices
